import { Grid, Input } from "@mui/material";
import React from "react";
import SearchIcon from "assets/SearchInputIcon.svg";

const InviteInput = ({
  handleOnChange,
  background = "#EFF3F4",
  value,
  placeholder = "Search Contact",
  width = "100%",
}: {
  handleOnChange: (e: any) => void;
  background?: string;
  value: string;
  placeholder?: string;
  width?: string;
}) => {
  return (
    <Input
      placeholder={placeholder}
      onChange={handleOnChange}
      value={value}
      startAdornment={
        <Grid
          sx={{
            minHeight: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={SearchIcon}
            style={{
              // background: "red",
              height: "25px",
              width: "25px",
            }}
          />
        </Grid>
      }
      sx={{
        padding: "5px 20px",
        gap: "8.384px",
        flexShrink: " 0",
        width: width,
        borderRadius: "60px",
        opacity: " 0.8",
        background,
        //placeholder
        input: {
          color: "#536371",
          fontFamily: "Helvetica Neue",
          fontSize: "14px",
          fontWeight: 400,
          paddingTop: "8px",
          "&::placeholder": {
            opacity: 0.6,
          },
        },
      }}
    />
  );
};

export default InviteInput;
